import SellerRelatedProducts from "../SellerRelatedProducts/SellerRelatedProducts";

import banner from "../../assets/banner.avif";
import '../SellerMoreRelated/SellerMoreRelated.css';

export default function SellerMoreRelated() {
  return (
    <>

<div className="sellermorerelated mb-5">
      <SellerRelatedProducts />
</div>
      
    </>
  );
}
